import { render, staticRenderFns } from "./read-drd-captions.component.vue?vue&type=template&id=52023cfe&scoped=true&"
import script from "./read-drd-captions.component.vue?vue&type=script&lang=ts&"
export * from "./read-drd-captions.component.vue?vue&type=script&lang=ts&"
import style0 from "./read-drd-captions.component.vue?vue&type=style&index=0&id=52023cfe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52023cfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
